import { render, staticRenderFns } from "./NavigationStepAdminNavList.vue?vue&type=template&id=15c53b5a"
import script from "./NavigationStepAdminNavList.vue?vue&type=script&lang=js"
export * from "./NavigationStepAdminNavList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports